import React from "react";
import { dateStatusOf } from "../utils/policyRegisterCsv";

// Prototype stats: Active inventory · Reviews overdue · Technical contradictions · Attestations complete.
const PolicyStatsStrip = ({ policyDocs = [], assurance = [], attestationSummary = [] }) => {
    const now = new Date();
    const active = policyDocs.filter(d => d.lifecycleStatus !== "Archived");
    // Live-row dates only (see dateStatusOf): an overdue review of an in-force version behind an open
    // revision is raised by the daily job, not counted here.
    const overdue = active.filter(d => dateStatusOf(d, now) === "Review overdue").length;
    const contradictions = (assurance || []).filter(r => r.status === "Contradiction").length;
    const unknown = (assurance || []).filter(r => r.status === "Unknown").length;
    const assigned = (attestationSummary || []).reduce((s, p) => s + (p.assignedCount || 0), 0);
    const attested = (attestationSummary || []).reduce((s, p) => s + (p.attestedAssignedCount || 0), 0);

    const stats = [
        { label: "Active inventory", value: active.length, sub: "Policies across the lifecycle", color: "text-indigo-600" },
        { label: "Reviews overdue", value: overdue, sub: "Owner action required", color: overdue ? "text-red-600" : "text-green-600" },
        { label: "Technical contradictions", value: contradictions, sub: unknown ? `${unknown} unknown (stale or missing evidence)` : "From live Security Insights controls", color: contradictions ? "text-orange-600" : "text-green-600" },
        { label: "Attestations complete", value: `${attested}/${assigned}`, sub: "Version-specific assignments", color: "text-blue-600" },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
            {stats.map(s => (
                <div key={s.label} className="bg-white border border-gray-200 rounded-xl p-4">
                    <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">{s.label}</div>
                    <div className={`text-2xl font-bold ${s.color}`}>{s.value}</div>
                    <div className="text-[11px] text-gray-400 mt-0.5">{s.sub}</div>
                </div>
            ))}
        </div>
    );
};

export default PolicyStatsStrip;
